import { render } from "./AdminEmail.vue?vue&type=template&id=3703875a&scoped=true"
import script from "./AdminEmail.vue?vue&type=script&lang=js"
export * from "./AdminEmail.vue?vue&type=script&lang=js"

import "./AdminEmail.vue?vue&type=style&index=0&id=3703875a&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3703875a"]])

export default __exports__